module.exports = {
      id: "star-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#star",
      toString: function () {
        return this.url;
      }
    }